'use client'

import { ImageLoaderProps } from 'next/image'

import { useEnv } from '@/app/_components/env-provider'

export default function CloudflareLoader({
  src,
  width,
  quality,
}: ImageLoaderProps): string {
  const env = useEnv()
  const params = [`width=${width}`, `quality=${quality || 75}`, 'format=auto']
  return `${env.CLOUDFLARE_IMAGE_RESIZING_URL}/${params.join(',')}/${src}`
}
